import classNames from 'classnames';
import styles from '../style.module.scss';

/**
 * Top navigation with shopping center logo link.
 */
export function VacanciesNavbar({ config }) {
  return (
    <nav
      className={classNames(styles.navbar, styles.navbarExpandLg)}
      role='navigation'
      aria-label='Main'
    >
      <div className={styles.containerFluid} id='vacancies-navbar'>
        <ul className={styles.navbarNav}>
          <li className={styles.navItem}>
            <a
              href={config.logoLinkUrl}
              className={styles.customLogoLink}
              rel='home noopener noreferrer'
              target='_blank'
            >
              <img src={config.logoUrl} alt={config.logoAlt} />
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}
